'use client'

import Logo from '$/public/logo/logo.svg'
import { animatePreload } from '@/animations/components'
import { useGSAPContext } from '@/hooks'
import { useStorePreload } from '@/store'
import { useRef } from 'react'

export interface PreloadProps {
  children: React.ReactNode
}

const Preload = ({ children }: PreloadProps) => {
  //refs
  const comp = useRef(null)
  const tl = useRef<GSAPTimeline | null>(null)

  //stores
  const { isPreloaded, setIsPreloaded, setStartAnimations } = useStorePreload()

  useGSAPContext({
    scope: comp,
    type: 'isomorphic',
    deps: [isPreloaded],
    callback: () => {
      if (!isPreloaded) {
        animatePreload(comp, tl, setIsPreloaded, setStartAnimations)
        tl.current?.play()
      }
    }
  })

  return (
    <>
      {children}
      {!isPreloaded && (
        <div
          ref={comp}
          className="bg-primary-200 text-whit fixed inset-0 z-2000 flex h-full w-full items-center justify-center text-white will-change-transform"
        >
          <div
            data-logo
            className="flex items-center justify-center will-change-transform"
          >
            <div
              className="relative h-20 w-40 overflow-hidden opacity-0"
              data-logo
            >
              <Logo />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Preload
